import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import LoginModal from "../components/Login/LoginModal";
import cairzLogo from "../assets/logoV1.png";
import { AuthContext } from "../contexts/AuthContext";
import { fetchPermissions } from "../utils/checkPermissions";
import handleLoginSuccess from "../components/Login/LoginModal";

function Header() {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { handleLogout, user, loading: authLoading, setUser, loginType, setLoginType } = useContext(AuthContext);
  const [permissions, setPermissions] = useState({ applicant: false, hcm: false });
  const [loadingPermissions, setLoadingPermissions] = useState(true);
  const [error, setError] = useState("");
  const [activeLink, setActiveLink] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Set active link based on current path
    const path = location.hash || location.pathname;
    if (path.includes('#intro')) setActiveLink('home');
    else if (path === '/about') setActiveLink('about');
    else if (path.includes('careers')) setActiveLink('careers');
    else if (path.includes('contactus')) setActiveLink('contactus');
    else if (path.includes('dashboard')) setActiveLink('dashboard');
    else if (path.includes('applicant')) setActiveLink('applicant');
  }, [location]);

  useEffect(() => {
    const storedLoginType = localStorage.getItem("loginType");
    if (storedLoginType) {
      setLoginType(storedLoginType);
    }
  }, []);

  // Check if user is logged in (including employee)
  const isLoggedIn = user || localStorage.getItem("employeeData");

  const setErrorMessage = (message) => {
    setError(message);
    setLoadingPermissions(false);
  };

  useEffect(() => {
    if (user && loginType) {
      const fetchPermissionsData = async () => {
        try {
          let resource;
          if (loginType === "job-seeker") {
            resource = "applicants";
          } else if (loginType === "employer") {
            resource = "dashboard";
          }

          const hasPermission = await fetchPermissions(
            loginType,
            resource,
            "view",
            loginType,
            setErrorMessage,
            navigate
          );

          setPermissions({
            applicant: loginType === "job-seeker" ? hasPermission : false,
            hcm: loginType === "employer" ? hasPermission : false,
          });
        } catch (error) {
          setErrorMessage("Failed to fetch permissions.....");
        }
      };

      fetchPermissionsData();
    }
  }, [user, loginType, navigate]);

  if (error) {
    return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;
  }

  const handleOpenModal = (type) => {
    setLoginType(type);
    setShowLoginModal(true);
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
    setLoginType("");
  };

  const handleDashboardClick = () => {
    setActiveLink('dashboard');
    navigate('/dashboard');
  };

  const linkStyle = (linkName) => ({
    color: activeLink === linkName ? '#007bff' : 'inherit',
    fontWeight: activeLink === linkName ? '600' : 'normal',
    transition: 'all 0.3s ease'
  });

  return (
    <>
      <header id="header" className="fixed-top">
        <div className="container">
        
          <div className="logo float-left" onClick={() => navigate("/#intro")}>
            <img src={cairzLogo} alt="Cairz Logo" className="img-fluid logo" style={{ cursor: "pointer" }} />
          </div>

          <button className="mobile-nav-toggle" onClick={() => setMobileMenuOpen((prev) => !prev)}>
            ☰
          </button>
          <nav className={`main-nav ${mobileMenuOpen ? "mobile-menu-open" : ""}`}>
            <ul>
              {user && (
                <>
                  <li><a href="/#intro" style={linkStyle('home')}>Home</a></li>
                  <li><a href="/about" style={linkStyle('about')}>About Us</a></li>
                  <li><a href="/careers" style={linkStyle('careers')}>Careers</a></li>
                  <li><a href="/contactus" style={linkStyle('contactus')}>Contact Us</a></li>
                </>
              )}

              {permissions.applicant && (
                <li><a href="/applicant" style={linkStyle('applicant')}>Applicant Dashboard</a></li>
              )}

              {permissions.hcm && (
                <li>
                  <a
                    href="#"
                    onClick={handleDashboardClick}
                    style={linkStyle('dashboard')}
                  >
                    HCM Dashboard
                  </a>
                </li>
              )}

              {!isLoggedIn ? (
                <>
                  <li>
                    <button className="btn btn-primary login-btn" onClick={() => handleOpenModal("job-seeker")}>
                      Job-Seeker Login
                    </button>
                  </li>
                  <li>
                    <button className="btn btn-secondary login-btn" onClick={() => handleOpenModal("employer")}> 
                      Management Login
                    </button>
                  </li>
                  <li>
                    <button className="btn btn-success login-btn" onClick={() => handleOpenModal("employee")}> 
                      Employee Login
                    </button>
                  </li>
                </>
              ) : (
                <li><button className="btn btn-danger login-btn" onClick={handleLogout}>Logout</button></li>
              )}
            </ul>
          </nav>
        </div>
      </header>

      {showLoginModal && (
        <LoginModal onClose={handleCloseModal} onLoginSuccess={handleLoginSuccess} loginType={loginType} />
      )}
    </>
  );
}

export default Header;